import { ApiError, fetchWithAuth, readBody } from "./client";

// Wraps POST /api/v1/dataset/ai-describe — used by the wizard's
// Review step to pre-populate the dataset description field from
// the user's filter + search + months. The portal route reads the
// OpenAI key from PortalConfig; the SPA gates the auto-fill on
// /api/me's ai_query_builder feature flag.

export interface AiDescribeRequest {
  months: string[];
  filter: string;
  search: string;
  output_format: string;
}

export interface AiDescribeResponse {
  description: string;
}

export async function describeDataset(
  req: AiDescribeRequest,
): Promise<AiDescribeResponse> {
  const res = await fetchWithAuth("/api/v1/dataset/ai-describe", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
  if (!res.ok) {
    throw new ApiError(
      res.status,
      await readBody(res),
      `/api/v1/dataset/ai-describe returned ${res.status}`,
    );
  }
  return (await res.json()) as AiDescribeResponse;
}
